'use client';
import JDILogin from '@/app/login/index.login';
import callAfterLogin from '@/app/login/utils/callAfterLogin';
import ArrowDown from '@/assets/icons/arrow-down.svg';
import CDNImage from '@/components/cdnImage/cdnImage';
import { useTranslation } from '@/i18n/client';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25061';
import cookieUtils from '@/intl-jdi-common-ssr/utils/cookieUtils';
import to from 'await-to-js';
import cn from 'clsx';
import { useEffect } from 'react';
import styles from './index.module.scss';
import { useStores } from '@/models';
import { observer } from 'mobx-react';

interface UserInfo {
  pin: string | null;
  nickName: string | null;
  avatar: string | null;
}
interface Props {
  cartNum: number;
  userInfo: UserInfo | null;
  disable?: boolean;
}

export const UserInfoButtonClient = observer(({ cartNum, userInfo, disable = false }: Props) => {
  const { t } = useTranslation();
  const { cartNumStore, userInfoStore } = useStores();
  const { displayCartNum, isCartNumValid } = cartNumStore;
  const myUserInfo = userInfoStore.userInfo || userInfo;

  useEffect(() => {
    cartNumStore.setCartNum(cartNum);
    userInfoStore.setUserInfo(userInfo);
  }, [cartNum, userInfo, cartNumStore, userInfoStore]);

  const handleLogin = () => {
    JDILogin.getInstance().openLoginDialog(
      disable ? { returnUrl: location.origin } : { returnUrl: location.href },
    );
    sendClickTrack.Header_Singin();
  };

  const handleSignOut = () => {
    cookieUtils.clearSessionStorage('isPrivacyPolicyUpdate');
    JDILogin.getInstance().logOut();
  };

  const handlerAddress = () => {
    callAfterLogin(() => {
      location.href = '/profile/my-address';
    });
  };

  const goProfileFn = () => {
    location.href = '/profile';
  };

  return (
    <>
      <div className={cn(styles.infoBox, styles.topBtnWrap)}>
        {myUserInfo?.pin ? (
          <div
            className={styles.meBtnWrap}
            exptag={'exp|' + EXPOSURE_RECORD.Header_Me_Expo}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            onClick={() => {
              sendClickTrack.Header_Me();
            }}
          >
            <button className={styles.meBtn} onClick={goProfileFn}>
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill='currentColor'
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M6.75057 8.00305C6.75057 5.10356 9.10107 2.75305 12.0006 2.75305C14.9001 2.75305 17.2506 5.10356 17.2506 8.00305C17.2506 10.9025 14.9001 13.2531 12.0006 13.2531C9.10107 13.2531 6.75057 10.9025 6.75057 8.00305ZM12.0006 1.25305C8.27265 1.25305 5.25057 4.27513 5.25057 8.00305C5.25057 11.731 8.27265 14.7531 12.0006 14.7531C15.7285 14.7531 18.7506 11.731 18.7506 8.00305C18.7506 4.27513 15.7285 1.25305 12.0006 1.25305ZM3.52046 22.304C4.94853 19.0355 8.20919 16.7537 12.0011 16.7537C15.793 16.7537 19.0537 19.0355 20.4818 22.304C20.6476 22.6835 21.0897 22.8568 21.4693 22.6909C21.8489 22.5251 22.0221 22.083 21.8563 21.7034C20.1981 17.9083 16.4105 15.2537 12.0011 15.2537C7.59176 15.2537 3.80409 17.9083 2.14593 21.7034C1.98009 22.083 2.15335 22.5251 2.53292 22.6909C2.91248 22.8568 3.35462 22.6835 3.52046 22.304Z'
                />
              </svg>
              <span>{t('header.profile')}</span>
              <ArrowDown className={styles.arrowDown} />
            </button>
            <div className={styles.meListDropdownLayer}>
              <ul className={styles.meList}>
                <li
                  className={cn(styles.meListItem, { [styles.disabled]: disable })}
                  onClick={disable ? undefined : goProfileFn}
                >
                  <div className={styles.meAvatarWrap}>
                    <div className={styles.meAvatar}>
                      <CDNImage
                        className={styles.meAvatarImg}
                        src={myUserInfo?.avatar || ''}
                        errorImgType={1}
                        width={60}
                        height={60}
                        alt={'Avatar'}
                        onClick={disable ? undefined : goProfileFn}
                      />
                    </div>
                    <span className={styles.meNickname}>{myUserInfo?.nickName}</span>
                  </div>
                </li>
                <li className={cn(styles.meListItem, { [styles.disabled]: disable })}>
                  <a href={disable ? '#' : '/profile/my-orders'}>{t('header.myOrder')}</a>
                </li>
                <li className={cn(styles.meListItem, { [styles.disabled]: disable })}>
                  <a href={disable ? '#' : '/profile/my-reviews'}>{t('header.myReview')}</a>
                </li>
                <li className={cn(styles.meListItem, { [styles.disabled]: disable })}>
                  <a href={disable ? '#' : '/profile/wishlist'}>{t('header.wishlist')}</a>
                </li>
                <li
                  className={cn(styles.meListItem, { [styles.disabled]: disable })}
                  onClick={disable ? undefined : handlerAddress}
                >
                  <a href={disable ? '#' : '/profile/my-address'}>{t('header.address')}</a>
                </li>
                <li className={styles.meListItem}>
                  <a
                    href='#'
                    className={cn(styles.signOut, { [styles.disabled]: disable })}
                    onClick={handleSignOut}
                  >
                    {t('header.signOut')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <div
            className={styles.unLoginBtn}
            exptag={'exp|' + EXPOSURE_RECORD.Header_Singin_Expo}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          >
            <button onClick={handleLogin}>
              <svg
                className={styles.meIcon}
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill='currentColor'
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M6.75057 8.00305C6.75057 5.10356 9.10107 2.75305 12.0006 2.75305C14.9001 2.75305 17.2506 5.10356 17.2506 8.00305C17.2506 10.9025 14.9001 13.2531 12.0006 13.2531C9.10107 13.2531 6.75057 10.9025 6.75057 8.00305ZM12.0006 1.25305C8.27265 1.25305 5.25057 4.27513 5.25057 8.00305C5.25057 11.731 8.27265 14.7531 12.0006 14.7531C15.7285 14.7531 18.7506 11.731 18.7506 8.00305C18.7506 4.27513 15.7285 1.25305 12.0006 1.25305ZM3.52046 22.304C4.94853 19.0355 8.20919 16.7537 12.0011 16.7537C15.793 16.7537 19.0537 19.0355 20.4818 22.304C20.6476 22.6835 21.0897 22.8568 21.4693 22.6909C21.8489 22.5251 22.0221 22.083 21.8563 21.7034C20.1981 17.9083 16.4105 15.2537 12.0011 15.2537C7.59176 15.2537 3.80409 17.9083 2.14593 21.7034C1.98009 22.083 2.15335 22.5251 2.53292 22.6909C2.91248 22.8568 3.35462 22.6835 3.52046 22.304Z'
                />
              </svg>
              <span>{t('header.signIn')}</span>
            </button>
          </div>
        )}
      </div>
      <div
        className={cn(styles.topBtnWrap, {
          [styles.cartButtonDisabled]: disable,
          [styles.cartButtonEnabled]: !disable,
        })}
        exptag={'exp|' + EXPOSURE_RECORD.Header_Cart_Expo}
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exptag-json-param={JSON.stringify({ name: 'cart' })}
        onClick={() => {
          sendClickTrack.Header_Cart();
        }}
      >
        <a href='/cart' target='_self'>
          <svg
            className={styles.topBtnIcon}
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fill='currentColor'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M1 2.25C0.585786 2.25 0.25 2.58579 0.25 3C0.25 3.41421 0.585786 3.75 1 3.75H3.43166C3.54678 3.75 3.64702 3.82862 3.67445 3.94042L4.51812 7.37873L6.73587 16.417C6.92791 17.1997 7.62959 17.75 8.43545 17.75H19.5343C20.3215 17.75 21.0118 17.2244 21.2212 16.4655L23.5483 8.03251C23.768 7.23649 23.1691 6.45 22.3433 6.45H5.83473L5.13124 3.58297C4.9392 2.80032 4.23752 2.25 3.43166 2.25H1ZM8.19266 16.0596L6.20279 7.95H22.015L19.7752 16.0665C19.7453 16.1749 19.6467 16.25 19.5343 16.25H8.43545C8.32033 16.25 8.22009 16.1714 8.19266 16.0596ZM8.5 22C9.32843 22 10 21.3284 10 20.5C10 19.6716 9.32843 19 8.5 19C7.67157 19 7 19.6716 7 20.5C7 21.3284 7.67157 22 8.5 22ZM18.5 22C19.3284 22 20 21.3284 20 20.5C20 19.6716 19.3284 19 18.5 19C17.6716 19 17 19.6716 17 20.5C17 21.3284 17.6716 22 18.5 22Z'
            />
          </svg>
          <span>{t('header.myCart')}</span>
          {isCartNumValid ? (
            <span id='jdi-header-cart-num' className={styles.cartNum}>
              {displayCartNum}
            </span>
          ) : null}
        </a>
      </div>
    </>
  );
});
